import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  // Simple mock authentication for testing
  // For now, let's just check if there's something in localStorage
  const { isAuthenticated, isInitialized } = useContext(AuthContext)

//   console.log("PrivateRoute - isInitialized:", isInitialized);
//   console.log("PrivateRoute - isAuthenticated:", isAuthenticated);

  // Show loading while auth is initializing
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;







// Old version of doing protected routes in react js

// import { Route, Redirect } from 'react-router-dom'

// const PrivateRoute = ({children, ...rest})=>{
//     console.log("Private routes work")
//     return (
//         <Route {...rest}>{children}</Route>
//     )
// }

// export default PrivateRoute;